// pages/MediaScreenDetail/MediaScreenDetail.js
//
// Media screen detail — the operator-facing deep-dive behind a Media Screens
// row. Section architecture mirrors the registry pattern (append a section
// object to SECTIONS and everything else is automatic). First section:
// Battery treatment — research-grade curves of how the pack has been used.

import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams, Link } from 'react-router-dom';
import { MonitorPlay, ArrowLeft, BatteryCharging, Tv, ExternalLink, UserRound } from 'lucide-react';
import { ggosDeviceService } from '../../services/api';
import BatterySection from './BatterySection';
import DeliverySection from './DeliverySection';
import './MediaScreenDetail.css';

const SECTIONS = [
  { id: 'battery', label: 'Battery treatment', icon: BatteryCharging, component: BatterySection },
  { id: 'delivery', label: 'Delivery & media value', icon: Tv, component: DeliverySection },
];

export default function MediaScreenDetail() {
  const { thingName } = useParams();
  const [params, setParams] = useSearchParams();
  const sectionId = params.get('section') || SECTIONS[0].id;
  const Active = (SECTIONS.find(s => s.id === sectionId) || SECTIONS[0]).component;

  // Identity from the (cached) board — renders progressively; the section
  // fetches its own data in parallel and never waits for this.
  const [row, setRow] = useState(null);
  useEffect(() => {
    let dead = false;
    ggosDeviceService.getMediaScreens({ q: thingName, segment: null })
      .then(j => { if (!dead && j.success) setRow((j.data.rows || []).find(r => r.thingName === thingName) || null); })
      .catch(() => {});
    return () => { dead = true; };
  }, [thingName]);

  return (
    <div className="msd-page">
      <div className="msd-head">
        <Link to="/media-screens" className="msd-back" aria-label="Back to Media Screens"><ArrowLeft size={18} /></Link>
        <MonitorPlay size={22} className="msd-head-icon" />
        <div className="msd-id">
          <h1>{row?.plate || row?.placementName || thingName}</h1>
          <div className="msd-sub">
            {row?.driverName && <span><UserRound size={12} /> {row.driverName}</span>}
            {row?.tenantName && <span>{row.tenantName}</span>}
            <span className="msd-thing">{thingName}</span>
            {row && (row.online
              ? <span className="msd-online">● online</span>
              : <span className="msd-offline">○ offline</span>)}
          </div>
        </div>
        <Link to={`/ggos-devices/${thingName}`} className="btn btn-secondary msd-devlink">
          <ExternalLink size={13} /> Full device page
        </Link>
      </div>

      <nav className="msd-tabs">
        {SECTIONS.map(s => {
          const Icon = s.icon;
          return (
            <button key={s.id}
              className={`msd-tab${s.id === sectionId ? ' is-active' : ''}`}
              onClick={() => { const n = new URLSearchParams(params); n.set('section', s.id); setParams(n, { replace: true }); }}>
              <Icon size={15} /> {s.label}
            </button>
          );
        })}
      </nav>
      <div className="msd-main">
        <Active thingName={thingName} />
      </div>
    </div>
  );
}
